module.exports = __webpack_public_path__ + "img/question-circle-regular.7aaa513a.svg";